<div class="price-lists-header" *ngIf="company$ | async as company">
  <img *ngIf="company === CompanyEnum.KIL" class="price-lists-header__logo" [src]="kaplanCompanyLogoPath" alt="kaplan logo" />
  <img *ngIf="company === CompanyEnum.ALP" class="price-lists-header__logo" [src]="alpadiaCompanyLogoPath" alt="alpadia logo" />
  <div class="price-lists-header__buttons">
    <lx-button
      *ngFor="let button of buttons"
      [text]="button.name"
      (buttonClick)="button.action()"
      buttonStyle="primary"
      size="s"
      [btnRounded]="true"
      [ngClass]="'lx-button--' + company | lowercase"
    ></lx-button>
    <ng-container *ngIf="priceListYears$ | async as years">
      <ng-container *ngIf="years.length > 1">
        <p-dropdown
          [options]="years"
          optionLabel="year"
          optionValue="year"
          [ngModel]="currentYear$ | async"
          (onChange)="onYearChange($event.value)"
          placeholder="Select a year"
          i18n-placeholder
        ></p-dropdown>
      </ng-container>
    </ng-container>
  </div>
</div>
